import { Component, Suspense, createElement, lazy, useState, type ComponentType, type ReactNode } from 'react';

export class DeferredPanelError extends Component<{ children: ReactNode; retry: () => void }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override render() {
    if (this.state.failed) return <div role="alert" className="rk-text-sm">
      <p>Не удалось открыть раздел.</p>
      <button type="button" className="rk-button-quiet" onClick={this.props.retry}>Повторить загрузку</button>
    </div>;
    return this.props.children;
  }
}

/** Load only when mounted. A retry creates a new lazy instance; it never calls form actions. */
export function deferredPanel<P extends object>(load: () => Promise<{ default: ComponentType<P> }>): ComponentType<P> {
  let current = lazy(load);
  return function DeferredPanel(props: P) {
    const [view, setView] = useState(() => ({ panel: current, attempt: 0 }));
    return <DeferredPanelError key={view.attempt} retry={() => {
      const panel = lazy(load); current = panel;
      setView(v => ({ panel, attempt: v.attempt + 1 }));
    }}>
      <Suspense fallback={<p role="status" className="rk-faint rk-text-sm">Загружаю раздел…</p>}>
        {createElement(view.panel as ComponentType<P>, props)}
      </Suspense>
    </DeferredPanelError>;
  };
}
